<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="name">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
    </wbo-search-form>
    <wbo-search-grid [styleOddRows]="false">
        <wbo-column field="name" [sortable]="false">
            <ng-template cellTemplate let-dataItem="dataItem">
                <div  [draggable]="entityModel.hasCategoryMovePrivilege"
                      (drop)="drop($event, dataItem)"
                      (dragover)="allowDrop($event, dataItem)"
                      (dragstart)="drag($event, dataItem)">
                    <span [style.margin-left]="(dataItem.level * 30) + 'px'" class="column_name">
                        <span class="collapse">
                            <fui-action *ngIf="searchModel.hasChildren(dataItem)"
                                        (click)="toggleCollapseCategory(dataItem)">
                                <fui-icon [height]="14" [icon]="'chevron-right'" [width]="15"
                                          *ngIf="searchModel.isCollapsed(dataItem)"></fui-icon>
                                <fui-icon [height]="14" [icon]="'chevron-down'" [width]="15"
                                          *ngIf="!searchModel.isCollapsed(dataItem)"></fui-icon>
                            </fui-action>
                        </span>
                        <fui-link-button *ngIf="!isSelectMode()" (click)="fireEditEvent(dataItem)"
                                         [title]="dataItem.name"></fui-link-button>
                        <span *ngIf="isSelectMode()">{{dataItem.name}}</span>
                        <fui-action *ngIf="entityModel.hasCategoryUpdatePrivilege" class="add-record"
                                    (click)="addRecord(dataItem)"
                                    [attr.title]="'wbo.common.button.add' | translate">
                            <fui-icon [height]="14" [icon]="'plus'" [width]="15"></fui-icon>
                        </fui-action>
                    </span>
                </div>
            </ng-template>
        </wbo-column>
        <wbo-actions-search-column *ngIf="entityModel.hasCategoryUpdatePrivilege || entityModel.hasCategoryMovePrivilege">
            <wbo-delete-search-action></wbo-delete-search-action>
            <wbo-add-search-action></wbo-add-search-action>
            <wbo-category-move-search-action *ngIf="entityModel.hasCategoryMovePrivilege"></wbo-category-move-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
